if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='662a5161a8']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "662a5161a8");
	style.appendChild(document.createTextNode(".dba930ea7a9438fd__root{display:contents}"));
	document.head.appendChild(style);
}
export default {"root":"dba930ea7a9438fd__root"};
